import { useState } from "react";
import { Calendar as CalendarIcon, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const FULL = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const MonthPicker = ({ value, onChange, placeholder = "Pick a month", className = "", "data-testid": testId, disabled }) => {
  const [open, setOpen] = useState(false);
  const [vy, vm] = value ? value.split("-").map(Number) : [null, null];
  const [year, setYear] = useState(vy || new Date().getFullYear());
  const label = vy && vm ? `${FULL[vm - 1]} ${vy}` : placeholder;
  return (
    <Popover open={open} onOpenChange={(o) => { setOpen(o); if (o && vy) setYear(vy); }}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" disabled={disabled} data-testid={testId}
          className={`w-full justify-start gap-2 px-3 text-left font-normal ${!value ? "text-muted-foreground" : ""} ${className}`}>
          <CalendarIcon className="h-4 w-4 shrink-0 opacity-60" />
          <span className="truncate">{label}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-3" align="start">
        <div className="flex items-center justify-between">
          <Button type="button" variant="ghost" size="icon" className="h-7 w-7" onClick={() => setYear((y) => y - 1)} data-testid="month-picker-prev-year"><ChevronLeft className="h-4 w-4" /></Button>
          <span className="text-sm font-semibold">{year}</span>
          <Button type="button" variant="ghost" size="icon" className="h-7 w-7" onClick={() => setYear((y) => y + 1)} data-testid="month-picker-next-year"><ChevronRight className="h-4 w-4" /></Button>
        </div>
        <div className="mt-2 grid grid-cols-3 gap-1.5">
          {MONTHS.map((m, i) => {
            const val = `${year}-${String(i + 1).padStart(2, "0")}`;
            const active = val === value;
            return (
              <Button key={m} type="button" size="sm" variant={active ? "default" : "ghost"} className="h-8 text-xs"
                onClick={() => { onChange(val); setOpen(false); }} data-testid={`month-option-${val}`}>{m}</Button>
            );
          })}
        </div>
      </PopoverContent>
    </Popover>
  );
};
